// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "mp-split-button{display:inline-block}:host{display:inline-block}.mp-split-button{display:flex}.mp-split-button.has-options mp-button{border-radius:6px 0 0 6px;margin-right:-1px}.mp-split-button mp-button{flex:1}.mp-split-button mp-select{--button-border-radius:0 6px 6px 0;flex:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
